module.exports = __webpack_public_path__ + "img/whatsapp.edf7b1d.svg";